var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "dashboard" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("h3", { staticClass: "card-title" }, [
                        _vm._v("Update Metrics"),
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary btn-block",
                          attrs: { disabled: _vm.isBusy },
                          on: { click: _vm.handleTriggerMetricUpdatesCommand },
                        },
                        [
                          _vm._v(
                            "\n                            Trigger Metrics Update\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "alert alert-danger", attrs: { role: "alert" } },
      [
        _c("h4", { staticClass: "alert-heading" }, [
          _vm._v("Warning: Advanced Operations Ahead"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                This page provides access to advanced troubleshooting commands that can significantly impact customer data and system functionality.\n                "
          ),
          _c("strong", [
            _vm._v("If you are unsure about a command, do not proceed."),
          ]),
          _vm._v(
            " Consult the documentation or seek guidance before making changes.\n            "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "card-text" }, [
      _vm._v(
        "\n                            Metric updates are automatically triggered by the system when data changes.\n                            "
      ),
      _c("strong", [
        _vm._v("Use this only if you suspect an issue due to a bug."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "card-text" }, [
      _vm._v(
        "\n                            Triggering a metric update requires updating all enterprise projects.\n                            "
      ),
      _c("strong", [_vm._v("Avoid running this command during peak hours")]),
      _vm._v(
        " to reduce the risk of disrupting active users.\n                        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }